import { render, staticRenderFns } from "./IntroView.vue?vue&type=template&id=f47c4a96&scoped=true&"
import script from "./IntroView.vue?vue&type=script&lang=js&"
export * from "./IntroView.vue?vue&type=script&lang=js&"
import style0 from "./IntroView.vue?vue&type=style&index=0&id=f47c4a96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47c4a96",
  null
  
)

export default component.exports